import gql from 'graphql-tag'
import { fragPostSummary } from '../fragments/post.js'
import { fragPageInfo, fragSeoPostYoastFragment } from '../fragments/seo.js'
import { fragCptAdv } from '../fragments/advertising.js'
import { fragRedirection } from '../fragments/redirect.js'

export const queryCategory = gql`
  ${fragSeoPostYoastFragment}
  ${fragPageInfo}
  ${fragPostSummary}
  ${fragRedirection}
  query QueryCategory(
    $wherePosts: RootQueryToPostConnectionWhereArgs
    $startCursorPosts: String
    $lastPosts: Int
    $endCursorPosts: String
    $firstPosts: Int = 15
    $uriPage: String
  ) {
    posts(
      before: $startCursorPosts
      last: $lastPosts
      after: $endCursorPosts
      first: $firstPosts
      where: $wherePosts
    ) {
      edges {
        node {
          ...FragPostSummary
        }
      }
      pageInfo {
        ...FragPageInfo
      }
    }
    pageBy(uri: $uriPage) {
      campiPagina {
        titoloPagina
        descrizionePagina
      }
      seo {
        ...FragSeoPostYoastFragment
      }
    }
    redirects {
      ...FragRedirection
    }
  }
`

export const queryCategoryIntegration = gql`
  ${fragSeoPostYoastFragment}
  ${fragPageInfo}
  ${fragPostSummary}
  ${fragRedirection}
  ${fragCptAdv}
  query QueryCategoryIntegration(
    $wherePosts: RootQueryToPostConnectionWhereArgs
    $startCursorPosts: String
    $lastPosts: Int
    $endCursorPosts: String
    $firstPosts: Int = 15
    $uriPage: String
  ) {
    posts(
      before: $startCursorPosts
      last: $lastPosts
      after: $endCursorPosts
      first: $firstPosts
      where: $wherePosts
    ) {
      edges {
        node {
          ...FragPostSummary
        }
      }
      pageInfo {
        ...FragPageInfo
      }
    }
    redirects {
      ...FragRedirection
    }
    pageBy(uri: $uriPage) {
      campiPagina {
        titoloPagina
        descrizionePagina
      }
      seo {
        ...FragSeoPostYoastFragment
      }
      advertising {
        acfAdv {
          ... on Advertising {
            advertisingType {
              cptAdv {
                ...FragCptAdv
              }
            }
          }
        }
      }
    }
  }
`
